/**
 * Sidebar collapse is user-driven only.
 * Viewport width must not collapse the menu on load or resize.
 */
export function resolveSidebarCollapsed(userPreference: boolean | null): boolean {
  return userPreference === true;
}
